import { render, staticRenderFns } from "./user-stat.vue?vue&type=template&id=4fac77b9&scoped=true"
import script from "./user-stat.vue?vue&type=script&lang=js"
export * from "./user-stat.vue?vue&type=script&lang=js"
import style0 from "./user-stat.vue?vue&type=style&index=0&id=4fac77b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac77b9",
  null
  
)

export default component.exports